// Locale validation lives in the survey-tool submodule, which is compiled as first-party source
// here. Single-sourcing it there is what keeps this app, campaign-preview-app and
// campaign-widget-app from each carrying their own copy of the same BCP-47 guard — the submodule
// hits the identical crash in its date dropdown. This module adds only the app-specific piece the
// submodule deliberately doesn't own: where an invalid tag gets reported.
import { DEFAULT_LOCALE, getSafeLocale as getSafeLocaleBase, isValidLocale } from '../survey-tool/utils/locale';
import { logErrorWithContext } from './log';

export { DEFAULT_LOCALE, isValidLocale };

/**
 * Returns `locale` if it is a valid BCP-47 tag, otherwise DEFAULT_LOCALE, reporting the rejected
 * value to telemetry.
 *
 * A non-zero count of `invalid locale, falling back` in production means a poisoning path we
 * haven't closed; the `locale` attribute names the offending value. The submodule's memo cache
 * dedups this, so each distinct bad value is reported once rather than on every rendered row.
 */
export function getSafeLocale(locale?: string | null): string {
  return getSafeLocaleBase(locale, (invalid) =>
    logErrorWithContext('invalid locale, falling back', { locale: invalid, fallback: DEFAULT_LOCALE })
  );
}
